import React, {Component} from 'react';
import {Timeline} from 'antd';

interface Properties {
  orderData: LooseObject;
}

class History extends Component<Properties> {
  getTimelineItems(history: Array<LooseObject>): Array<JSX.Element> {
    const result: Array<JSX.Element> = history.map((content: LooseObject, i: number) => {
      const getColor = (type: any, err: any) => {
        switch (type) {
          case 'info':
            return 'green';
          case 'pending':
            return 'orange';
          case 'error':
            return 'red';
          default:
            if (err && !type) {
              return 'red';
            }

            return 'green';
        }
      };

      return (
        <Timeline.Item key={i} color={getColor(content.type, content.err)}>
          {content.message}
        </Timeline.Item>
      );
    });
    return result;
  }

  render(): JSX.Element {
    const {history} = this.props.orderData.order;
    return (
      <>
        <h3 style={{fontWeight: 600, marginBottom: 16}}>History:</h3>
        <Timeline className="historyTimeline">{this.getTimelineItems(history)}</Timeline>
      </>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/History/History.tsx